package br.com.texeratx.boardgametimeapp.ui.screens.clan

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import br.com.texeratx.boardgametimeapp.core.image.ImageSourcePickerDialog
import br.com.texeratx.boardgametimeapp.core.image.rememberImageSourceState
import br.com.texeratx.boardgametimeapp.ui.screens.myclans.ClanMembersScreen
import br.com.texeratx.boardgametimeapp.ui.screens.myclans.MyClansScreen
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.getScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow

class ClanScreen : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val vm = getScreenModel<ClanViewModel>()
        val state by vm.state.collectAsState()
        val imageSource = rememberImageSourceState { picked ->
            if (picked != null) vm.onImageSelected(picked)
        }

        ImageSourcePickerDialog(imageSource)

        LaunchedEffect(Unit) {
            if (state.clan == null && !state.isLoading) vm.loadMe()
        }

        ClanUI(
            state = state,
            onBack = { navigator.pop() },
            onRetry = vm::loadMe,
            onEdit = vm::startEdit,
            onCancel = vm::cancelEdit,
            onNameChange = vm::onNameChange,
            onRequireApprovalChange = vm::onRequireApprovalChange,
            onPickImage = imageSource.onLaunch,
            onClearImage = vm::clearLocalImage,
            onSave = vm::save,
            onOpenMembers = {
                state.clan?.id?.let { navigator.push(ClanMembersScreen(it)) }
            },
            onLeave = {
                vm.leaveClan { navigator.replaceAll(MyClansScreen()) }
            },
        )
    }
}
